<template>
  <div style="width: 100%; height: 100%">
    <el-container style="width: 100%; height: 100%">
      <el-aside width="auto">
        <leftMenu></leftMenu>
      </el-aside>
      <el-main>
        <div style="height: 100%">
          <navMenu></navMenu>
          <div style="width: 100%; height: calc(100% - 96px)">
            <keep-alive :include="keepAliveInclude">
              <router-view></router-view>
            </keep-alive>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import leftMenu from "../layout/leftMenu/leftMenu.vue";
import navMenu from "../layout/navMenu/navMenu.vue";
import { mapGetters } from 'vuex'

export default{
  name: "App",
  components: {
    leftMenu,
    navMenu,
  },
  computed: {
    ...mapGetters(['keepAliveInclude'])
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
/deep/.el-aside {
  overflow: hidden;
}
.el-main {
  position: relative;
  padding: 0;
  background-color: #030e20;
}
</style>
